import { useEffect } from "react";

export const Disclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="disclaimer-page">
      {/* Header */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <p className="text-[0.625rem] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-4">
              Legal
            </p>
            <h1 className="text-3xl md:text-5xl tracking-[0.02em] text-white/90 mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
              Disclaimer
            </h1>
            <p className="text-white/40 text-sm">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-8 text-white/70 font-light leading-relaxed">
              
              <div className="p-6 bg-[#1a1405] border border-[#D4AF37]/30 rounded-lg">
                <p className="text-[#D4AF37] font-medium mb-2">Important Notice</p>
                <p>
                  The information provided on this website is for general informational purposes only. All information is provided in good faith; however, we make no representation or warranty of any kind regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>1. Investment Disclaimer</h2>
                <p>
                  Goldnote products are collectible precious metal items and should not be considered as investment advice. The value of precious metals can fluctuate significantly based on market conditions. Past performance is not indicative of future results. You should consult with a qualified financial advisor before making any investment decisions.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>2. Product Information</h2>
                <p>
                  While we strive to provide accurate product descriptions, images, and specifications, we do not warrant that product descriptions or other content is accurate, complete, reliable, current, or error-free. Product colors may vary slightly due to photographic and screen display variations.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>3. Pricing Disclaimer</h2>
                <p>
                  Prices for precious metal products are subject to change based on market conditions without prior notice. The price at the time of purchase will be the final price. We are not responsible for pricing errors and reserve the right to cancel orders resulting from such errors.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>4. External Links</h2>
                <p>
                  Our website may contain links to third-party websites. We have no control over the content, privacy policies, or practices of these sites and assume no responsibility for them. The inclusion of any link does not imply endorsement or recommendation.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>5. Authenticity Verification</h2>
                <p>
                  Our QR authentication system is designed to verify the authenticity of Goldnote products. However, we cannot guarantee the system will be error-free or uninterrupted. Always purchase from authorized dealers and verify products through official channels.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>6. Limitation of Liability</h2>
                <p>
                  Under no circumstances shall Goldnote Corporation, its directors, employees, or agents be liable for any direct, indirect, incidental, special, punitive, or consequential damages arising from:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 mt-4">
                  <li>Your use or inability to use our website or products</li>
                  <li>Any errors or omissions in our content</li>
                  <li>Unauthorized access to or alteration of your data</li>
                  <li>Statements or conduct of any third party on our website</li>
                  <li>Market fluctuations affecting precious metal values</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>7. Warranty Disclaimer</h2>
                <p>
                  Our products are provided "as is" without warranty of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement, except where such disclaimers are prohibited by law.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>8. Jurisdictional Limitations</h2>
                <p>
                  Some jurisdictions do not allow the exclusion of certain warranties or limitations on liability. In such cases, our liability will be limited to the maximum extent permitted by applicable law.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>9. Contact</h2>
                <p>
                  If you have any questions about this Disclaimer, please contact us at:
                </p>
                <p className="mt-4">
                  <strong className="text-[#D4AF37]">Goldnote Corporation</strong><br />
                  Email: legal@goldnote.com<br />
                  Phone: 1-800-GOLDNOTE
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
